import { useLabelForEstimatedDeliveryPeriod, useLabelForEstimatedPaymentDate, } from '../../hooks/useLabel';
import { useTranslation } from 'react-i18next';
export var getSecondsFromNow = function (date) {
    return Math.floor((date.valueOf() - new Date().valueOf()) / 1000);
};
export var toOrderedItem = function (itemType, item, roaster) {
    var _a, _b;
    if (itemType === 'Offer') {
        var offer = item;
        return {
            id: offer.id,
            type: 'Offer',
            offer: offer,
            orderAmount: 0,
            minOrder: offer.minOrder,
            bagSize: offer.bagSize,
            remainingQuantity: offer.remainingQuantity,
            sampleRemainingQuantity: (_a = offer.sampleQuantity) !== null && _a !== void 0 ? _a : 0,
            totalQuantity: offer.quantity,
            alreadySampleOrdered: Boolean(offer.isSampleOrdered),
            isFoundingRoasterItem: isFoundingRoasterItem(offer, roaster),
        };
    }
    var typicaStockItem = item;
    return {
        id: typicaStockItem.id,
        type: 'TypicaStockItem',
        offer: typicaStockItem.offer,
        orderAmount: 0,
        minOrder: typicaStockItem.minOrder,
        bagSize: typicaStockItem.bagSize,
        remainingQuantity: typicaStockItem.remainingQuantity,
        sampleRemainingQuantity: typicaStockItem.sampleRemainingQuantity,
        totalQuantity: typicaStockItem.quantity,
        alreadySampleOrdered: Boolean(typicaStockItem.isSampleOrdered),
        isFoundingRoasterItem: isFoundingRoasterItem(typicaStockItem.offer, roaster),
        transportToWarehousesStatus: ((_b = typicaStockItem.offer.offerList.roasterTransportToWarehouse) === null || _b === void 0 ? void 0 : _b.status) ||
            'packing',
    };
};
var isFoundingRoasterItem = function (offer, roaster) {
    if (!offer.offerList.roaster)
        return false;
    return offer.offerList.roaster.id === roaster.id;
};
export var usePaymentTimingExplanation = function (value, offerList) {
    var t = useTranslation().t;
    var estimatedPaymentDate = useLabelForEstimatedPaymentDate();
    var estimatedDeliveryPeriod = useLabelForEstimatedDeliveryPeriod();
    if ((offerList === null || offerList === void 0 ? void 0 : offerList.estimatedPaymentDate) && value === 'one_time_upfront') {
        return t('pages.roasterOrder.oneTimeUpfrontExplanations', {
            paymentDate: estimatedPaymentDate(offerList),
        });
    }
    else if (value === 'one_time_after_imported' ||
        value === 'one_time_specified_date' ||
        value === 'one_time_after_first_delivery' ||
        value === 'after_each_delivery' ||
        value === 'one_time_upfront') {
        return t('pages.roasterOrder.paymentTimingExplanation');
    }
    else if (value === 'lump_sum_payment_after_import') {
        return t('pages.roasterOrder.afterImportPaymentExplanations', {
            deliveryPeriod: estimatedDeliveryPeriod(offerList === null || offerList === void 0 ? void 0 : offerList.roasterTransportToWarehouse),
        });
    }
    else {
        return t('pages.roasterOrder.fewTimesPaymentAfterImportExplanations', {
            deliveryPeriod: estimatedDeliveryPeriod(offerList === null || offerList === void 0 ? void 0 : offerList.roasterTransportToWarehouse),
        });
    }
};
